import { ListLinkSimple } from "type/common/array/ListLinkSimple.type";

export function arrStrToListLinkSimple(arr: string[]): ListLinkSimple<string> {
  const res: ListLinkSimple<string> = {};
  const n: number = arr.length;

  if (n >= 2) {
    for (let i = 0; i <= n - 2; i++) {
      const val1 = arr[i];
      const val2 = arr[i + 1];
      res[val1] = val2;
    }
    res[arr[n - 1]] = arr[0];
  } else {
    const val = arr[0];
    res[val] = val;
  }

  return res;
}

export function arrSimpleEqual(arr1: any[], arr2: any[]): boolean {
  return JSON.stringify(arr1) === JSON.stringify(arr2);
}

export function arrEqualsAsPureSets<T>(a: T[], b: T[]): boolean {
  const setA = new Set(a);
  const setB = new Set(b);

  if (setA.size !== setB.size) return false;

  // Convert to array before iteration
  return Array.from(setA).every((elem) => setB.has(elem));
}

export function filterDuplicates<T>(
  arr: Array<T>,
  areDuplicates: (a: T, b: T) => boolean
): Array<T> {
  const result: T[] = [];

  for (let i = 0; i < arr.length; i++) {
    const a = arr[i];
    const el = result.find((b: T) => areDuplicates(a, b));
    if (!el) {
      result.push(a);
    }
  }

  return result;
}

export function filterDuplicatesSuccesive<T>(
  arr: Array<T>,
  areDuplicates: (a: T, b: T) => boolean
): Array<T> {
  const result: T[] = [];

  if (arr.length >= 1) {
    result.push(arr[0]);
  }

  if (arr.length >= 2) {
    for (let i = 1; i < arr.length; i++) {
      const a = arr[i];
      const currentIsDuplicate = areDuplicates(a, result[result.length - 1]);
      if (!currentIsDuplicate) {
        result.push(a);
      }
    }
  }

  return result;
}
